import request from '@/base/service'
const newBaseURL =  process.env.VUE_APP_IMG_URL
const requestC = (data) => {
  return request({...data, ...{ baseURL: newBaseURL } })
}
//  登录
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

//  登出
export function logout(data) {
  return request({
    url: '/logout',
    method: 'get',
    params: data
  })
}

export function getUserInfo() {
  return request({
    url: '/site/getCurrentUser',
    method: 'get'
  })
}


// 查询全部用户名
export function getUserList(data) {
  return request({
    url: '/cus/user',
    method: 'get',
    params: data
  })
}
// 修改累计在线时间
export function importTime(data) {
  return request({
    url: '/home/importTime',
    method: 'post',
    data
  })
}
// 邮件数量设置
export function mailCountSet(data) {
  return request({
    url: '/zdyx/mailCountSet',
    method: 'post',
    data
  })
}
// 邮件主题模板
export function mailTitleSetTemplate(data) {
  return request({
    url: '/zdyx/mailTitleSetTemplate',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 收件箱模板
export function inBoxSetTemplate(data) {
  return request({
    url: '/zdyx/inBoxSetTemplate',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 发件箱模板
export function sendBoxSetTemplate(data) {
  return request({
    url: '/zdyx/sendBoxSetTemplate',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// EDM列表
export function edmListSetTemplate(data) {
  return request({
    url: '/zdyx/edmListSetTemplate',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 热门帖子
export function hotPostsTemplate(data) {
  return request({
    url: '/social/hotPostsTemplate',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 社交推广
export function socialPromoteTemplate(data) {
  return request({
    url: '/social/socialPromoteTemplate',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 站点查询

export function onlineQuery(data) {
  return request({
    url: '/site/online/query',
    method: 'post',
    data
  })
}

// 版本套餐
export function packagesQuery() {
  return request({
    url: '/site/query/packages',
    method: 'get',
  })
}

// 行业
export function industryQuery() {
  return request({
    url: '/site/query/industry',
    method: 'get',
  })
}

